<template>
    <div class="kb-breadcrumb">
        <div class="kb-breadcrumb__itemcontainer" v-bind:key="item.linkText" v-for="item in itemList">
            <h1 class="kb-breadcrumb__itemheading" v-if="item.isHeadline === true">
                {{ item.linkText }}
            </h1>
            <span class="kb-breadcrumb__itemspan" v-if="item.isHeadline === false">
                <kb-base-link :href="item.url" class="kb-breadcrumb__itemlink jt-breadcrumb" :link-props="{title: item.linkText}">{{ item.linkText }}</kb-base-link> <span class="kb-breadcrumb__itemlinkappendix">&gt;</span>
            </span>
        </div>
    </div>
</template>

<script>
import BaseLink from '@/components/Atoms/BaseLink/BaseLink'

export default {
    name: "kb-breadcrumb",
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    computed: {
        itemList: function() {
            let listItems = [];
            this.items.forEach(element => {
                element.isHeadline = false;
                listItems.push(element);
            });
            listItems[listItems.length -1].isHeadline = true;

            return listItems;
        }
    }
}

</script>

<style lang="scss" scoped>
.kb-breadcrumb {
    font-family: $fontFamily;
    width:100%;
    box-sizing: border-box;

    &__itemcontainer {
        position: relative;
        display: inline-block;
        height: 1rem;
    }

    &__itemlink {
        font-size: 12px;
        color: $cPrimary;
        line-height: 1rem;
    }

    &__itemlinkappendix {
        padding: 0 .5rem;
    }

    &__itemspan {
        font-size: 12px;
        color: $cPrimary;
    }

    &__itemheading {
        margin:0;
        padding:0;
        font-size:12px;
        line-height: 1rem;
        margin-block-start: 0;
        margin-block-end: 0;
    }

    &__itemheading &__itemlink {
        text-decoration: none;
    }

    &__itemspan &__itemlink {
        text-decoration: underline;
        font-weight: bold;
    }

    &__itemspan &__itemlink:hover {
        text-decoration: none;
    }
}
</style>
